/**
 * エリアに関する定数
 */

/**
 * 成田空港を非表示にするフラグ
 * true: 一般ユーザー向け画面で成田空港を表示しない
 * false: 成田空港を表示する
 */
export const HIDE_NARITA_AIRPORT = true;

/**
 * 空港
 */
export const AIRPORTS = {
  HANEDA: 'haneda',
  NARITA: 'narita',
} as const;

export type Airport = (typeof AIRPORTS)[keyof typeof AIRPORTS];

/**
 * フライト種別
 */
export const FLIGHT_TYPES = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international',
} as const;

export type FlightType = (typeof FLIGHT_TYPES)[keyof typeof FLIGHT_TYPES];

/**
 * ターミナル
 */
export const TERMINALS = {
  TERMINAL1: 'terminal1',
  TERMINAL2: 'terminal2',
  TERMINAL3: 'terminal3',
  SATELLITE2: 'satellite2',
  SATELLITE5: 'satellite5',
} as const;

export type Terminal = (typeof TERMINALS)[keyof typeof TERMINALS];

/**
 * ラウンジ
 */
export const LOUNGES = {
  ANA_LOUNGE: 'ana_lounge',
  SUITE_LOUNGE: 'suite_lounge',
  COMMON: 'common',
} as const;

export type Lounge = (typeof LOUNGES)[keyof typeof LOUNGES];
